import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import add from "../../images/add.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";

// Lucide Icons
import { FolderPlus, X, Check, Tag, Hash, Save } from "lucide-react";
import "./AddTemplateCategory.css";
import { useAlert } from "react-alert";

export function AddTemplateCategory({ getTemplateCategory, setShow }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});

  const [inputData, setInputData] = useState({
    name: "",
  });

  const validateForm = () => {
    const newErrors = {};

    if (!inputData.name.trim()) {
      newErrors.name = "Category name is required";
    } else if (inputData.name.length < 3) {
      newErrors.name = "Category name must be at least 3 characters";
    } else if (inputData.name.length > 50) {
      newErrors.name = "Category name must be less than 50 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      if (inputData?.name) {
        setLoader(true);
        let payload = {
          _id: adminStore.admin.admin._id,
          name: inputData.name,
        };
        const signalResponse = await api.addTemplateCategory(payload);
        // console.log(signalResponse);
        if (signalResponse?.success) {
          alert.success("Template Category added successfully");
          setInputData({
            name: "",
          });
          setLoader(false);
          getTemplateCategory();
          setShow(false);
          // sendNotification()
        } else {
          setLoader(false);
          alert.error("Something went wrong");
        }
      } else {
        setLoader(false);
        alert.error("Please insert all fields");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert.error("Something went wrong");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <>
      <div className="add-category-container">
        {/* Header */}
        <div className="category-header">
          <div className="header-icon">
            <FolderPlus size={28} className="icon-primary" />
          </div>
          <div className="header-content">
            <h2 className="category-title">Add New Category</h2>
            <p className="category-subtitle">
              Create a new template category to organize your templates
            </p>
          </div>
        </div>

        {/* Form */}
        <div className="category-form">
          <div className="form-group">
            <label htmlFor="categoryName" className="form-label">
              <Tag size={16} />
              Category Name
            </label>
            <div className="input-wrapper">
              <div className="input-icon">
                <Hash size={18} />
              </div>
              <input
                type="text"
                id="categoryName"
                value={inputData?.name}
                onChange={(e) =>
                  setInputData({
                    ...inputData,
                    name: e.target.value,
                  })
                }
                onKeyPress={handleKeyPress}
                className={`form-input ${errors.name ? "error" : ""}`}
                placeholder="e.g., Marketing, Legal, HR, etc."
                autoFocus
              />
              {inputData.name && (
                <button
                  className="clear-input"
                  onClick={() => setInputData({ ...inputData, name: "" })}
                >
                  <X size={16} />
                </button>
              )}
            </div>
            {errors.name && (
              <div className="error-message">
                <X size={12} />
                <span>{errors.name}</span>
              </div>
            )}
            <div className="input-hint">
              Choose a descriptive name that helps identify the template type
            </div>
          </div>

          {/* Character Counter */}
          {inputData.name && (
            <div className="character-counter">
              <div
                className={`counter ${
                  inputData.name.length > 50 ? "exceeded" : ""
                }`}
              >
                {inputData.name.length}/50
              </div>
              <div className="counter-label">characters</div>
            </div>
          )}

          {/* Example Categories */}
          <div className="examples-section">
            <div className="examples-label">
              <span>Examples:</span>
            </div>
            <div className="examples-tags">
              {[
                "Marketing",
                "Legal",
                "HR Documents",
                "Sales",
                "Onboarding",
                "Finance",
              ].map((example, index) => (
                <button
                  key={index}
                  className="example-tag"
                  onClick={() => setInputData({ ...inputData, name: example })}
                >
                  {example}
                </button>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="action-buttons">
            <button className="cancel-btn" onClick={() => setShow(false)}>
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="submit-btn"
              disabled={!inputData.name.trim() || loader}
            >
              {loader ? (
                <div className="btn-loader"></div>
              ) : (
                <>
                  <Save size={18} />
                  <span>Create Category</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}
